<template>
  <div id="team-invoices-container" class="w-full">
    <table id="team-invoices-table" class="hidden sm:table w-full">
      <thead>
        <tr>
          <th
            scope="col"
            v-for="(col, index) in header"
            :key="index"
            :class="
              `${col.css} font-semibold text-ma-gray-3 text-sm leading-7 px-3 pt-3 pb-0`
            "
          >
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rIndex) in data"
          :key="rIndex"
          class="hover:bg-ma-gray-0"
        >
          <td
            v-for="(col, cIndex) in header"
            :data-th="col.name"
            :key="rIndex + '_' + cIndex"
            class="text-sm py-2 px-3 font-medium"
            :class="col.css"
          >
            <span v-if="col.id === 'link'">
              <a :href="row.link">Invoice</a>
            </span>
            <span v-else-if="col.id === 'date'">
              {{ row[col.id] | DATE("MMMM D, YYYY", true) }}
            </span>
            <span v-else-if="col.id === 'amount'">
              {{ row[col.id] | CURRENCY}}
            </span>
            <span v-else>
              {{ row[col.id]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="team-invoices-cards" class="block sm:hidden w-full py-1">
      <div
        v-for="(card, index) in data"
        :key="index"
        class="bg-ma-gray-0 w-100 p-4 m-3 text-left"
      >
        <div class="text-sm font-semibold flex justify-between text-ma-black-1">
          <div>{{ card.number }}</div>
          <div>{{ card.amount | CURRENCY }}</div>
        </div>
        <div class="text-sm font-medium text-ma-gray-3 leading-none">
          {{ card.date | DATE("MMMM D, YYYY", true) }}
        </div>
        <div
          class="text-sm font-semibold text-ma-blue-1 cursor-pointer hover:text-ma-blue-0 pt-4"
          @click="download(card.link)"
        >
          Invoice
        </div>
      </div>
    </div>
    <iframe ref="downloadFrame" style="display:none;"></iframe>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    header: {
      type: Array,
      required: false,
      default: [],
    },
    data: {
      type: Array,
      required: false,
      default: [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    download(url) {
      this.$refs.downloadFrame.src = url;
    }
  }
};
</script>

<style scoped></style>
